<template>
  <main id="app" v-bind:class="$store.state.isKiosk ? ($store.state.isLogged ? 'kioskComp' : 'kioskCompLogin') : ''" @click="setInteraction()">
    <SideMenu v-if="this.$store.state.isLogged"></SideMenu>
    <div v-bind:class="this.$store.state.isLogged ? 'mainContent' : ''">
      <HeaderNav v-if="this.$store.state.isLogged"></HeaderNav>
      <transition name="slide-fade" mode="out-in" appear>
          <router-view/>
      </transition>
    </div>
    <ContactModal></ContactModal>
    <ReportsModal v-if="this.$store.state.user.type >= 2"></ReportsModal>
  </main>
</template>

<script>
  import ReportsModal from './components/Modals/ReportsModal';
  import ContactModal from './components/Modals/ContactModal';
  import SideMenu from './components/Common/SideMenu.vue'
  import HeaderNav from './components/Common/HeaderNav.vue'
  import imageToBase64 from 'image-to-base64';

export default {
    name: 'App',
    data(){
        return {
        }
    },
    methods:{
        goBack(){
            if(window.routerLastFrom == 'login'){
                this.$router.push('/');
            }else {
                this.$router.go(-1);
            }
        },
        setInteraction(){
            this.$store.state.lastInteraction = Math.floor(Date.now() / 1000);
        },
        loadPrintAssets(){
            if(this.$store.state.printAssets.logo === "") {
                const url = this.$store.state.app.admin.id !== 2 && this.$store.state.app.logo !== '' ? 'https://' + this.$store.state.app.domain + '/logos/' + (this.$store.state.app.kioskLogo ? this.$store.state.app.kioskLogo : this.$store.state.app.logo) : 'https://app.seatup.co.il/static/images/kioskPrintLogo.png';
                imageToBase64(url).then(
                    base64Logo => {
                        base64Logo = `data:image/${url.indexOf("png") !== -1 ? 'png' : 'jpeg'};base64,${base64Logo}`;
                        this.$store.state.printAssets.logo = base64Logo;
                    });
            }
            if(this.$store.state.printAssets.divider === "") {
                imageToBase64('https://app.seatup.co.il/static/images/divider.png').then(
                    base64Logo => {
                        base64Logo = `data:image/png;base64,${base64Logo}`;
                        this.$store.state.printAssets.divider = base64Logo;
                    });
            }
        }
    },
    beforeMount(){
        window.seatupApp = this;
    },
    mounted(){
        if(this.$store.state.isKiosk){
            let _this = this;

            $('body').off('mousemove').on('mousemove',function(){
                _this.setInteraction()
            });
            $('body').off('mouseover').on('mouseover',function(){
                _this.setInteraction()
            });
            $('body').off('scroll').on('scroll',function(){
                _this.setInteraction()
            });
            $('body').off('touchstart').on('touchstart',function(){
                _this.setInteraction()
            });
        }

    },
    components:{
        ContactModal,
        ReportsModal,
        SideMenu,
        HeaderNav,
    },
}

</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
  .kioskView{
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    position: fixed !important;
    width: 100% !important;
  }
</style>
